export default "__VITE_ASSET__fjZ1L8oJ__"